"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useLangContext_1 = require("../../../../hooks/useLangContext");
const Text_1 = __importDefault(require("../../../_core/Text"));
const TableRow_1 = __importDefault(require("../TableRow"));
const locales_1 = __importDefault(require("./locales"));
const TaskItem = ({ formatPrice, task }) => {
    const { lang, syncLocales } = (0, useLangContext_1.useLangContext)();
    syncLocales(locales_1.default);
    const subtitleLines = task.subtitle
        ? task.subtitle
            .split('\n')
            // Keep empty lines on the resulting invoice as non-breaking spaces
            // to avoid collapsing the table rows.
            .map((line) => (line.trim() === '' ? '\xA0' : line))
        : [];
    const hasSubtitle = subtitleLines.length > 0;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableRow_1.default, { ...(hasSubtitle && { paddingBottom: 'space-4' }) },
            react_1.default.createElement(TableRow_1.default.ColumnDetails, null,
                react_1.default.createElement(Text_1.default, { fontWeight: "weight-500" }, task.title)),
            react_1.default.createElement(TableRow_1.default.ColumnUnits, null,
                react_1.default.createElement(Text_1.default, null, task.units.toLocaleString(lang))),
            react_1.default.createElement(TableRow_1.default.ColumnUnitPrice, null,
                react_1.default.createElement(Text_1.default, null, formatPrice(task.unitPrice))),
            react_1.default.createElement(TableRow_1.default.ColumnVatPercentage, null,
                react_1.default.createElement(Text_1.default, null, locales_1.default.formatString(locales_1.default.percentage, {
                    percentage: task.vatPercentage.toLocaleString(lang),
                }))),
            react_1.default.createElement(TableRow_1.default.ColumnTotalWithoutTaxes, null,
                react_1.default.createElement(Text_1.default, null, formatPrice(task.totalAmountBeforeTaxes)))),
        // Span description over multiple rows to help the PDF generation
        // split pages more nicely.
        subtitleLines.map((descriptionLine, idx) => (react_1.default.createElement(TableRow_1.default, { key: idx, paddingY: "0", ...(idx === subtitleLines.length - 1 && {
                paddingBottom: 'space-8',
            }) },
            react_1.default.createElement(TableRow_1.default.ColumnDetails, null,
                react_1.default.createElement(Text_1.default, { whiteSpace: "pre-wrap" }, descriptionLine)))))));
};
exports.default = TaskItem;
